import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { COLUMN_VALUE_DATE } from "../../model/OrdersTableDefinitionFactory.constants";

import { TenorAdapter } from "./TenorAdapter";
import { CurrencyPairCalendarLookupService, ColumnDefinition } from "../../index";
import { MappedCurrencyPairCalendarImpl } from "../../model/mapped/MappedCurrencyPairCalendarImpl";
import { DateAdapter } from "../DateAdapter";

// String types that are sortable as an Int32 in C++ module
export class TenorValueDateAdapter extends DateAdapter {
  private tenorAdaptor = new TenorAdapter();

  constructor(protected currencyPairCalendarLookupService: CurrencyPairCalendarLookupService) {
    super();
    this.localeString = "DD-MMM-YY";
  }

  adapt(column: ColumnDefinition, row: any, ...modelObjects: any[]): void {
    super.adapt(column, row, ...modelObjects);
  }

  retrieveData(order: CubiqTS.OrderDataImpl, _: string): string {
    let tenor: any = order.settleTenor;
    let adjustedTenor: any = order.adjustedSettleTenor;
    if (tenor) {
      let ccyPairKey = `${order.baseCode}${order.nonBaseCode}`;

      let calendar: MappedCurrencyPairCalendarImpl = this.currencyPairCalendarLookupService.getItem(
        ccyPairKey,
      ) as MappedCurrencyPairCalendarImpl;

      if (!calendar) {
        return this.tenorAdaptor.getTenorStr(tenor);
      } else if (CubiqTS.Product.SPT === order.product || CubiqTS.Product.FWD === order.product) {
        let tenorToValueDate: CubiqTS.TenorToValueDate = null;
        if (adjustedTenor && calendar.tenorToValueDateMap.has(adjustedTenor)) {
          tenorToValueDate = calendar.tenorToValueDateMap.get(adjustedTenor);
        } else if (calendar.tenorToValueDateMap.has(tenor)) {
          tenorToValueDate = calendar.tenorToValueDateMap.get(tenor);
        }
        if (tenorToValueDate) {
          let valueDate = super.retrieveData(tenorToValueDate, "valueDate");
          return `${this.tenorAdaptor.getTenorStr(tenor)} (${valueDate})`;
        } else {
          return `${this.tenorAdaptor.getTenorStr(tenor)} (-)`;
        }
      } else if (
        CubiqTS.Product.NDF === order.product &&
        calendar.tenorToValueAndFixingDateMap.has(tenor)
      ) {
        let valueDateAndFixing = calendar.tenorToValueAndFixingDateMap.get(tenor);
        let valueDate = super.retrieveData(valueDateAndFixing, "valueDate");

        return `${this.tenorAdaptor.getTenorStr(tenor)} (${valueDate})`;
      } else {
        return `${this.tenorAdaptor.getTenorStr(tenor)} (-)`;
      }
    }
    return super.retrieveData(order, COLUMN_VALUE_DATE);
  }

  retrieveSort(order: CubiqTS.OrderDataImpl, _: string): number {
    let tenor: any = order.settleTenor;
    if (tenor) {
      let ccyPairKey = `${order.baseCode}${order.nonBaseCode}`;
      let calendar = this.currencyPairCalendarLookupService.getItem(
        ccyPairKey,
      ) as MappedCurrencyPairCalendarImpl;
      let valueDate: CubiqTS.StandardDateImpl = null;
      let valueDateSortable: number;

      if (!calendar) {
        // As per INVALID TDR, sort by Tenor
        return order.settleTenor;
      } else if (
        (CubiqTS.Product.SPT === order.product || CubiqTS.Product.FWD === order.product) &&
        calendar.tenorToValueDateMap.has(tenor)
      ) {
        let tenorToValueDate = calendar.tenorToValueDateMap.get(tenor);

        valueDate = tenorToValueDate.valueDate;
      } else if (
        CubiqTS.Product.NDF === order.product &&
        calendar.tenorToValueAndFixingDateMap.has(tenor)
      ) {
        let valueDateAndFixing = calendar.tenorToValueAndFixingDateMap.get(tenor);

        // return `${this.tenorAdaptor.getTenorStr(tenor)} (${valueDate})`;
        valueDate = valueDateAndFixing.valueDate;
      }

      // milliseconds on a StandardDate (day boundary).
      // add Tenor to this value for correct sort
      if (valueDate)
        valueDateSortable = CubiqTS.moment([
          valueDate.year,
          valueDate.month - 1,
          valueDate.day,
        ]).valueOf();
      else valueDateSortable = super.retrieveSort(order, COLUMN_VALUE_DATE);

      return valueDateSortable + order.settleTenor;
    }

    // milliseconds on a StandardDate (day boundary).
    // Tenor.ALL sorts after other tenors so add for a correct broken date sort
    return super.retrieveSort(order, COLUMN_VALUE_DATE) + CubiqTS.Tenor.ALL;
  }

  retrieveFilter(order: any, columnProperty: string): string {
    var tenor: any = order.settleTenor;
    if (tenor) {
      return tenor.toString();
    } else {
      if (order.settleDate) {
        let calendar: MappedCurrencyPairCalendarImpl =
          this.currencyPairCalendarLookupService.getItem(
            `${order.baseCode}${order.nonBaseCode}`,
          ) as MappedCurrencyPairCalendarImpl;
        for (var value of calendar.tenorToValueDateMap.values()) {
          let vDt = new Date(
            value.valueDate.year,
            value.valueDate.month - 1,
            value.valueDate.day,
          ).valueOf();
          let stDate = new Date(
            order.settleDate.year(),
            order.settleDate.month(),
            order.settleDate.date(),
          ).valueOf();
          if (vDt == stDate) {
            return value.tenor.toString();
          } else if (vDt > stDate) return (value.tenor - 0.5).toString();
        }
      }
    }
    return "-1";
  }
}
